import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a750413"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wind-radar-ui" }
const _hoisted_2 = { class: "shapes" }
const _hoisted_3 = { class: "circles" }
const _hoisted_4 = { class: "lines" }
const _hoisted_5 = { class: "ticks" }
const _hoisted_6 = { class: "labels" }
const _hoisted_7 = {
  key: 0,
  class: "data"
}
const _hoisted_8 = {
  viewBox: "-200 -200 400 400",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_9 = ["x1", "y1", "x2", "y2"]
const _hoisted_10 = ["x1", "y1", "x2", "y2"]

import { computed } from 'vue'
import { WIND_DIRECTION_LABELS } from '@/lib/constants'

type WindRadarPropsType = {
  values?: number[]
}


export default /*#__PURE__*/_defineComponent({
  props: {
    values: null
  },
  setup(__props: any) {

const props = __props as {
  values?: number[]
}

const R = 200 // 外周の円半径
const LABELS_R = 213 // ラベルが通る円の半径
const MIN_DEG = 22.5 // 最小の角度
const RAD_PER_DEG = Math.PI / 180 // 1degあたりのラジアン
const TICK_NUM = 10 // 目盛りの数



// 軸の最大値 最大値が50を超えていれば外周の最大値を100%にする
const maxR = computed(() => {
  if (props.values === undefined) {
    return 50
  }

  const maxValue = Math.max(...props.values)

  return maxValue > 0.5 ? 100 : 50
})

const ticks = computed(() => {
  const tick = maxR.value / TICK_NUM

  return Array.from(Array(TICK_NUM)).map((_, index) => {
    return tick * (index + 1)
  })
})

const labels = computed(() => {
  return Object.keys(WIND_DIRECTION_LABELS)
    .filter(key => key !== '00')
    .map(key => {
      return {
        index: Number(key),
        text: WIND_DIRECTION_LABELS[key as keyof typeof WIND_DIRECTION_LABELS],
      }
    })
})

const points = computed(() => {
  if (props.values === undefined) {
    return []
  }

  return props.values
    .filter((_, index) => index > 0)
    .map((v, _index) => {
      const index = _index - 3 // 東を0にする
      const r = (R / maxR.value) * v * 100
      const deg = MIN_DEG * index
      const x = r * Math.cos(deg * RAD_PER_DEG)
      const y = r * Math.sin(deg * RAD_PER_DEG)

      return { x, y }
    })
})

const labelStyle = (_index: number) => {
  const index = _index - 4 // 東を0にする
  const deg = MIN_DEG * index
  let left = LABELS_R * Math.cos(deg * RAD_PER_DEG)
  const top = LABELS_R - LABELS_R * Math.sin(-deg * RAD_PER_DEG)

  // 三文字のラベルが円にかぶるので少しずらす
  if (Math.abs(index) % 2 === 1) {
    left += left > 0 ? 10 : -10
  }

  return {
    left: `${left}px`,
    top: `${top}px`,
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (index) => {
          return _createElementVNode("div", {
            key: index,
            class: "circle"
          })
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (index) => {
          return _createElementVNode("div", {
            key: index,
            class: "line"
          })
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ticks), (tick, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "tick"
          }, _toDisplayString(tick), 1))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(labels), (label) => {
          return (_openBlock(), _createElementBlock("div", {
            key: label.index,
            style: _normalizeStyle(labelStyle(label.index)),
            class: "label"
          }, _toDisplayString(label.text), 5))
        }), 128))
      ]),
      (__props.values && __props.values.length >= 16)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(), _createElementBlock("svg", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.max(0, _unref(points).length - 1), (index) => {
                return (_openBlock(), _createElementBlock("line", {
                  key: index,
                  x1: _unref(points)[index - 1]?.x,
                  y1: _unref(points)[index - 1]?.y,
                  x2: _unref(points)[index]?.x,
                  y2: _unref(points)[index]?.y,
                  stroke: "#0076C8",
                  "stroke-width": "2"
                }, null, 8, _hoisted_9))
              }), 128)),
              (_unref(points).length > 0)
                ? (_openBlock(), _createElementBlock("line", {
                    key: 0,
                    x1: _unref(points)[_unref(points).length - 1]?.x,
                    y1: _unref(points)[_unref(points).length - 1]?.y,
                    x2: _unref(points)[0]?.x,
                    y2: _unref(points)[0]?.y,
                    stroke: "#0076C8",
                    "stroke-width": "2"
                  }, null, 8, _hoisted_10))
                : _createCommentVNode("", true)
            ]))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})